import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { Constants } from '../data/constants'
import { Product, ProductInfos } from '../data/product'
import { ProductDetails } from '../data/productDetails'
import { BasicConnectors } from '../data/vehicleOptions'

type CodeTotalWithoutPrefix = string

const fetchProductsDetails = async (codeTotalWithoutPrefix: CodeTotalWithoutPrefix): Promise<ProductDetails[]> => {
  const codeTotal = Constants.CODE_PREFIX + codeTotalWithoutPrefix
  const url = `api/places/${codeTotal}/services`

  return fetch(url).then(response => {
    if (!response.ok) {
      throw new Error('Request failed when fetching details for: ' + codeTotal)
    }

    return response.json()
  })
}

const filterProducts = (
  productDetails: ProductDetails[],
  basicConnectors?: BasicConnectors,
  optionalConnectors?: string[]
): ProductDetails => {
  let availableProducts: Product[] = []
  let productMapping: ProductInfos[] = []
  let nbCompatibleProducts = 0

  if (!basicConnectors) {
    return productDetails[0]
  }

  for (let p of productDetails[0].products) {
    if (
      basicConnectors?.standardPlug === p.services[0].connectors[0].standard ||
      (basicConnectors?.fastPlugObject?.fastPlug === p.services[0].connectors[0].standard &&
        basicConnectors?.fastPlugObject?.fastPlugOptional === false) ||
      optionalConnectors?.indexOf(p.services[0].connectors[0].standard) !== -1
    ) {
      nbCompatibleProducts++

      if (p.availableAssetCount !== 0 || p.occupiedAssetCount !== 0 || p.unknownAssetCount !== 0) {
        availableProducts = [...availableProducts, p]
        productMapping = [
          ...productMapping,
          { serviceId: p.services[0].id, productTariffId: p.services[0].connectors[0].tariffId }
        ]
      }
    }
  }

  return {
    stationInfos: productDetails[0].stationInfos,
    products: availableProducts,
    productMapping: productMapping,
    nbCompatibleProducts: nbCompatibleProducts
  }
}

export const useProductsQuery = (
  codeTotalWithoutPrefix: CodeTotalWithoutPrefix,
  basicConnectors?: BasicConnectors,
  optionalConnectors?: string[]
) =>
  useQuery(
    ['product-details', `${Constants.CODE_PREFIX}${codeTotalWithoutPrefix}`],
    () => fetchProductsDetails(codeTotalWithoutPrefix),
    {
      select: useCallback((response: any) => filterProducts(response.data, basicConnectors, optionalConnectors), []),
      enabled: codeTotalWithoutPrefix.length === 6
    }
  )
